import axios from "../../interceptors/axiosInterceptor";
import {
  ASSIGN_PLAN_URL,
  ASSIGN_TOUR_URL,
  CHECK_RIDER_ASSIGNMENT,
  CHECK_TOUR_ASSIGNMENT,
  REASSIGN_TOUR_URL,
} from "../../config/Url";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";
import { IAssignTourPayload, IGetQueryParams, IReassignTourPayload } from "../../interfaces/Index";

export const checkTourOrRiderAssignment = (
  queryParam: IGetQueryParams,
  isTour: boolean
) =>
  new Promise<string[]>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    const url = isTour ? CHECK_TOUR_ASSIGNMENT : CHECK_RIDER_ASSIGNMENT;
    axios
      .get(url, requestConfig)
      .then((response) => {
        if (response) {
          const data: string[] = response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const reassignTourApiCall = (payload: IReassignTourPayload) =>
new Promise<void>((resolve, reject) => {
  axios
    .post(REASSIGN_TOUR_URL, payload, getAuthOptions())
    .then(() => resolve())
    .catch((error) => {
      const errorPayload = normalizeCatchErrors(error.response);
      reject(errorPayload);
    });
});

export const assignTourApiCall = (payload: IAssignTourPayload) =>
  new Promise<void>((resolve, reject) => {
    axios
      .post(ASSIGN_TOUR_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const assignPlanApiCall = (payload: string[]) =>
  new Promise<void>((resolve, reject) => {
    axios
      .post(ASSIGN_PLAN_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
